import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.css';
import i18n from '../../langsconfig/i18n';

const ConfirmAlert = (title = "update-operation", onConfirm, onClose) => {
    confirmAlert({
        customUI: ({ onClose: close }) => (
            <div className="confirm-alert-wrapper">
                <div className="confirm-alert-box animate-in">
                    <h4>{i18n.t(title)}</h4>
                    <p>{i18n.t('confirmation-question')}</p>
                    <div className="buttons">
                        <button
                            onClick={() => {
                                triggerClose(close, onClose);
                            }}
                        >
                            {i18n.t('No')}
                        </button>
                        <button
                            onClick={() => {
                                onConfirm();
                                triggerClose(close, onClose);
                            }}
                        >
                            {i18n.t('Yes')}
                        </button>
                    </div>
                </div>
            </div>
        )
    });
};

const triggerClose = (close, onClose) => {
    const box = document.querySelector('.confirm-alert-box');
    if (box) {
        box.classList.remove('animate-in');
        box.classList.add('animate-out');
        setTimeout(() => {
            close();
            if (onClose) onClose();
        }, 300);
    } else {
        close();
        if (onClose) onClose();
    }
};

export default ConfirmAlert;
